import React from 'react';
import { IConcreteJobConfirmationPopupProperties } from '../jobs-monitor-host.viewmodel';

const deleteEventJobProperties: IConcreteJobConfirmationPopupProperties<null> = {
        reviewFailedJobButtonText: 'Ok',
        reviewCompletedJobButtonText: 'Ok',
        completeComponent: () => null,
        failedComponent: () => {
            return <>{`Event deletion has failed`}</>;
        },
};

export { deleteEventJobProperties };